import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Header.css";
import Logo from "../assets/updeals.png";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="header-wrapper">
      <div className="header-container">
        <Link to="/" className="brand-link" onClick={closeMenu}>
          <img src={Logo} alt="UpDeals" className="brand-logo" />
          <span className="brand-text">UpDeals</span>
          <span className="brand-badge">Loot</span>
        </Link>

        <nav className={`header-nav ${menuOpen ? "open" : ""}`}>
          <ul className="nav-links">
            <li>
              <Link to="/" className={location.pathname === "/" ? "active" : ""} onClick={closeMenu}>
                Deals Feed
              </Link>
            </li>
            <li>
              <Link to="/about" className={location.pathname === "/about" ? "active" : ""} onClick={closeMenu}>
                About
              </Link>
            </li>
            <li>
              <Link to="/contact" className={location.pathname === "/contact" ? "active" : ""} onClick={closeMenu}>
                Contact
              </Link>
            </li>
            <li>
              <Link to="/privacy" className={location.pathname === "/privacy" ? "active" : ""} onClick={closeMenu}>
                Privacy
              </Link>
            </li>
            <li>
              <Link to="/terms" className={location.pathname === "/terms" ? "active" : ""} onClick={closeMenu}>
                Terms
              </Link>
            </li>
          </ul>

          <div className="header-actions">
            <a
              href="https://chat.whatsapp.com/EOSD1FRKL8DG9OXo5qfE2b?mode=ems_copy_t"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-header-wa"
              title="Join WhatsApp Group"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0012.04 2zm5.8 14.15c-.24.67-1.39 1.29-1.92 1.37-.5.08-1.13.11-3.28-.78-2.56-1.06-4.21-3.69-4.34-3.86-.13-.17-1.04-1.38-1.04-2.64 0-1.25.66-1.87.89-2.12.24-.25.52-.31.69-.31.18 0 .35 0 .5.01.16.01.38-.06.59.45.22.53.75 1.83.82 1.96.07.13.11.29.02.46-.08.18-.13.29-.26.44-.13.15-.28.34-.39.46-.13.13-.26.27-.11.53.15.25.66 1.09 1.42 1.77.98.87 1.8 1.14 2.06 1.27.26.13.41.11.56-.07.15-.17.65-.76.82-1.02.18-.26.35-.22.59-.13.24.09 1.54.73 1.8 1.02.27.29.44.43.51.55.07.12.07.7-.17 1.37z" />
              </svg>
              WhatsApp
            </a>
            <a
              href="https://t.me/updealzz"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-header-tg"
              title="Join Telegram Channel"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.75-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .37z" />
              </svg>
              Telegram
            </a>
          </div>
        </nav>

        <button
          className="mobile-toggle"
          onClick={toggleMenu}
          aria-label="Toggle navigation menu"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            {menuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>
    </header>
  );
};

export default Header;
